import { orderBy } from 'lodash'
import { LearningItem } from '../../models/LearningItem'
import { firstBookingForLearningItemForUserUuid } from './bookingForLearningItem'

type Assignment = Exclude<LearningItem['userLearningAssignments'], null | undefined>[number] | undefined

function processLearningItems(userLearningItems: LearningItem[], filterKind: string[], userUuid: string | null) {
  return userLearningItems
    .filter((learningItem) => filterKind.includes(learningItem.kind))
    .filter((learningItem) => {
      if (filterKind.includes('onDemandCourse') || filterKind.includes('scheduledCourse')) {
        return (
          firstBookingForLearningItemForUserUuid(userUuid!, learningItem) ||
          learningItem.userLearningAssignments?.length
        )
      }

      return learningItem.userLearningAssignments?.length
    })
    .filter(({ learningProgress }) => !learningProgress?.completedAt)
    .map((learningItem) => ({
      learningItem,
      assignment: orderBy(
        learningItem.userLearningAssignments || [],
        [({ dueDate }) => dueDate?.toISOString() || 'z', ({ createdAt }) => createdAt?.toISOString() || ''],
        ['asc', 'desc']
      )[0] as Assignment,
    }))
    .map((element) => {
      if (element?.learningItem) {
        element.learningItem.userLearningAssignments = orderBy(
          element.learningItem.userLearningAssignments || [],
          [(assignment) => assignment.dueDate?.toISOString() || 'z'],
          ['asc']
        )
      }

      return element
    })
}

export default function unfinishedLearningItems(userLearningItems: LearningItem[], userUuid: string) {
  return processLearningItems(userLearningItems, ['onDemandCourse', 'scheduledCourse'], userUuid)
}

export function unfinishedLearningPaths(userLearningItems: LearningItem[]) {
  return processLearningItems(userLearningItems, ['learningPath'], null)
}
